
import './plugins/bootstrap-vue'
import './plugins/icons-vue'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'

import routes from './router'
import guard from './router/guard'
import messages from './i18n'

import numeral from 'numeral'
import numFormat from 'vue-filter-number-format'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueI18n)
Vue.filter('numFormat', numFormat(numeral));

const render = h => h('div', { attrs: { id: 'app' } }, [
  h('RouterView')
])

const i18n = new VueI18n({ locale: 'es', messages })

const router = new VueRouter({
  routes  
})

guard({ router, i18n })

new Vue({
  router,
  render,
  i18n,
}).$mount('#app')